var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.537 10.095h-.783v-.04h-8.755v3.89h5.498A5.834 5.834 0 0 1 6.162 12 5.837 5.837 0 0 1 12 6.163c1.488 0 2.841.562 3.872 1.479l2.751-2.752A9.68 9.68 0 0 0 12 2.272c-5.372 0-9.728 4.356-9.728 9.728S6.627 21.728 12 21.728s9.728-4.356 9.728-9.728c0-.652-.068-1.289-.19-1.905"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m3.393 7.472 3.196 2.344a5.83 5.83 0 0 1 5.41-3.653c1.487 0 2.84.562 3.872 1.479l2.751-2.752a9.68 9.68 0 0 0-6.623-2.618 9.72 9.72 0 0 0-8.606 5.2M12 21.728a9.68 9.68 0 0 0 6.522-2.526l-3.011-2.547A5.8 5.8 0 0 1 12 17.837a5.83 5.83 0 0 1-5.488-3.865L3.34 16.416c1.61 3.15 4.88 5.312 8.66 5.312"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m21.538 10.095-.008-.04H12v3.89h5.497a5.86 5.86 0 0 1-1.987 2.71h.001l3.01 2.547c-.212.193 3.206-2.338 3.206-7.202 0-.652-.067-1.289-.189-1.905"
})));
export default SvgGoogle;